module.exports = __webpack_public_path__ + "static/media/Samantha M.c9601dfb.png";